import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { PromotionAction } from 'src/app/models/promotionAction.model';
import { AuthService } from 'src/app/services/auth.service';
import { SebbieService } from 'src/app/services/sebbie.service';

@Component({
  selector: 'promotion-history',
  standalone: false,
  templateUrl: './promotion-history.component.html',
  styleUrl: './promotion-history.component.scss'
})
export class PromotionHistoryComponent implements OnInit {
  pastPromotions: PromotionAction[] = [];
  initLoading: boolean = true;
  loading: boolean = false;
  error: boolean = false;

  constructor(
    private readonly sebbieService: SebbieService,
    private readonly authService: AuthService,
    @Inject(PLATFORM_ID) protected _platformId: Object,
  ) { }

  async ngOnInit(): Promise<void> {
    this.sebbieService.continuationTokenHistory = null;
    this.pastPromotions = [];
    await this.loadPromotions();
    this.initLoading = false;
  }

  private async loadPromotions(): Promise<void> {
    if(isPlatformServer(this._platformId)){
      return;
    }

    if(this.loading || this.error){
      return;
    }

    if(this.sebbieService.continuationTokenHistory === null && this.pastPromotions.length > 0){
      return; //no more results
    }

    this.loading = true;

    try {
      const promotions = await this.sebbieService.getPastPromotionActionsForUser(this.authService.authorizationHeaderValue);
      this.pastPromotions = [...this.pastPromotions, ...promotions];
    } catch (error) {
      this.error = true;
      console.error('Error fetching past promotions');
    } finally {
      this.loading = false;
    }
  }
}
